import React from "react";

class AboutModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {

        return (
            <div id="modal-about" className="modal-bg display-none" data-modalid="modal-about" onClick={this.props.closeButton}>
                <div className="modal-container modal-about" onClick={this.props.stopPropagation}>
                    <div className="modal-content">
                        <button className="icon-button modal-close-button" data-modalid="modal-about" onClick={this.props.closeButton}>
                            <svg enableBackground="new 0 0 256 256" height="256px" id="Layer_1" version="1.1" viewBox="0 0 256 256" width="256px" xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"><path d="M137.051,128l75.475-75.475c2.5-2.5,2.5-6.551,0-9.051s-6.551-2.5-9.051,0L128,118.949L52.525,43.475  c-2.5-2.5-6.551-2.5-9.051,0s-2.5,6.551,0,9.051L118.949,128l-75.475,75.475c-2.5,2.5-2.5,6.551,0,9.051  c1.25,1.25,2.888,1.875,4.525,1.875s3.275-0.625,4.525-1.875L128,137.051l75.475,75.475c1.25,1.25,2.888,1.875,4.525,1.875  s3.275-0.625,4.525-1.875c2.5-2.5,2.5-6.551,0-9.051L137.051,128z"/></svg>
                        </button>
                        <h2>About</h2>
                        <p>
                            Welcome to Mahjong Space!  This is a sci-fi themed Mahjong Solitaire!
                        </p>
                        <br />
                        <h3>How to Play</h3>
                        <p>
                            The objective of Mahjong Space is to remove tiles by matching them until the board is clear.  Tiles can only be matched if they are open.  Tiles are considered open if they do not have a tile on top of them, and if they can be freely moved left or right without touching another tile.
                        </p>
                        <p>
                            This version of Mahjong Solitaire affords you two shuffles that can be used to shuffle the remaining tiles in place.  You are free to shuffle whenever you wish, but you may want to wait until you run out of matches before doing so.
                        </p>
                        <p>
                            You are also given a hint button, which will reveal one of the available matches.  After using it, the hint button has a 30 second cooldown period where it can't be used.
                        </p>
                        <p>
                            Additonally, you are able to toggle the highlighting of open tiles at any time.
                        </p>
                        <br />
                        <h3>
                            Support
                        </h3>
                        <p>
                            This game is provided for free on the internet.  If you wish to donate to support independent game development, you can buy me a space coffee at <a href="https://ko-fi.com/wbrueske">ko-fi.com/wbrueske.</a>
                        </p>
                        <p>
                            Thanks for playing!  Enjoy!
                        </p>
                        <br />
                    </div>
                </div>
            </div>
        );
    }
}

export default AboutModal;